import { P2GBox, P2GGrid, P2GRating, P2GText } from '@parcel2go/core-ui';
import QuoteFilterSection, { QuoteFilterCheckbox } from './quote-filter-section';
import { QuoteFilterOptions } from '~/lib/quotes';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

function RatingFilterOptions({
  filter,
  title,
  dataTestId,
  onChange
}: {
  filter: QuoteFilterOptions;
  title: string;
  dataTestId: string;
  onChange: (filter: QuoteFilterOptions) => void;
}) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);
  const allRatings = [5, 4, 3];

  return (
    <QuoteFilterSection title={title} dataTestId={dataTestId}>
      <P2GGrid container spacing={1} direction="column">
        {allRatings.map((rating) => {
          const isSelected = !!filter.ratings?.includes(rating);
          return (
            <P2GGrid item key={rating}>
              <QuoteFilterCheckbox
                disable={false}
                isSelected={isSelected}
                onClick={() => onChange({ ...filter, ratings: isSelected ? [] : [rating] })}
                label={
                  <P2GBox display="flex" alignItems="center" gap={1}>
                    <P2GRating rating={rating} />
                    {rating !== 5 && (
                      <P2GText variant="body2">
                        <Trans i18nKey="RATING_AND_UP" t={t}>
                          & Up
                        </Trans>
                      </P2GText>
                    )}
                  </P2GBox>
                }
              />
            </P2GGrid>
          );
        })}
      </P2GGrid>
    </QuoteFilterSection>
  );
}

export default RatingFilterOptions;
